import { render, staticRenderFns } from "./users-list-modal.vue?vue&type=template&id=f06358b2&scoped=true&"
import script from "./users-list-modal.vue?vue&type=script&lang=js&"
export * from "./users-list-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06358b2",
  null
  
)

export default component.exports